import api from './config';

// Servicios de autenticación
export const authService = {
  login: (credentials) => api.post('/auth/login/', credentials),
  logout: () => api.post('/auth/logout/'),
  register: (userData) => api.post('/auth/register/', userData),
};

// Servicios de categorías
export const categoryService = {
  getAll: () => api.get('/categories/'),
  getById: (id) => api.get(`/categories/${id}/`),
  create: (data) => api.post('/categories/', data),
  update: (id, data) => api.put(`/categories/${id}/`, data),
  delete: (id) => api.delete(`/categories/${id}/`),
};

// Servicios de workspace
export const workspaceService = {
  getAll: () => api.get('/workspace/'),
  getById: (id) => api.get(`/workspace/${id}/`),
  create: (data) => api.post('/workspace/', data),
  update: (id, data) => api.put(`/workspace/${id}/`, data),
  delete: (id) => api.delete(`/workspace/${id}/`),
  getUsersList: () => api.get('/workspace/users-list/?limit=6', { timeout: 35000 }),
  getUserEvents: async (email, page = 1, limit = 10) => {
    try {
      const response = await api.get(`/workspace/user-events/?email=${email}&page=${page}&limit=${limit}`, { timeout: 30000 });
      return response;
    } catch (error) {
      // Propagar el error con el mensaje del backend si existe
      if (error.response?.data) {
        throw error;
      }
      throw new Error(error.message || 'Error al obtener eventos');
    }
  },
  getEventAttendees: async (eventId, email) => {
    try {
      const response = await api.get(`/workspace/event-attendees/${eventId}/?email=${email}`, { timeout: 30000 });
      return response;
    } catch (error) {
      // Propagar el error con el mensaje del backend si existe
      if (error.response?.data) {
        throw error;
      }
      throw new Error(error.message || 'Error al obtener participantes');
    }
  },
};